const INITIAL_STATE = {
  data: null,
  error: null,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_SPECIAL_PROMOTIONS_SUCCESS":
      return { ...state, data: action.payload };

    case "GET_SPECIAL_PROMOTIONS_FAIL":
      return { ...state, error: action.payload };

    default:
      return state;
  }
};
